import { Pill } from "@clipboard-health/ui-components";
import { type SxProps } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { formatDollarsAsUsd } from "@src/appV2/lib/Money/utils/currency";

export interface PayoutFeePillProps {
  fee: number;
  sx?: SxProps<Theme>;
}

function getPillLabel(fee: number): string {
  if (fee <= 0) {
    return "No fee";
  }

  return `${formatDollarsAsUsd(fee)} fee per payout`;
}

export function PayoutFeePill(props: PayoutFeePillProps) {
  const { fee, sx } = props;

  return <Pill label={getPillLabel(fee)} size="small" sx={sx} />;
}
